import React from 'react';
import {WorkflowDiagramNode} from './WorkflowDiagramNode';

export interface WorkflowDiagramNodesProps {
    nodes?: any;
}

export const WorkflowDiagramNodes: React.FunctionComponent<WorkflowDiagramNodesProps> = ({
                                                                                             nodes
                                                                                         }) => {
    const genericUserInput = nodes.find((node: any) => node.type === 'generic_user_input');
    if (genericUserInput) {
        //genericUserInput.hasNext = false;
    }
    // note: if generic user input is the only node in list, then assume we are already "nested"
    const shouldHandleGeneric = false; //(genericUserInput && genericUserInput.status === 'active' && nodes.length > 1);

    // if the genericUserInput is active, show it grouped with Initiate New Request note
    const filteredNodes = /* shouldHandleGeneric ? */ nodes.filter((node: any) => node.type !== 'generic_user_input') ;//: nodes;
    const initiateNewRequest = filteredNodes.slice(0, 1)[0];
    //initiateNewRequest.hasNext = false;

    const workflowNodes = (shouldHandleGeneric) ?
        [
            genericUserInput,
            /*
            {
                type: 'group',
                hasNext: true,
                nodeGroups: [
                    [
                        genericUserInput
                    ],
                    [
                        ...(filteredNodes.slice(0, 1))
                    ],
                ],
            },
            */
            ...(filteredNodes.slice(1))
        ]
        :
        filteredNodes;

    return (
        <div className="workflow-nodes">
            {workflowNodes.map((node: any, index: number) => (
                node.type === 'group' ?
                    <React.Fragment key={index}>
                    <div style={{flexGrow: 1}}>
                        {node.nodeGroups.map((n: any) => <WorkflowDiagramNodes nodes={n}/>)}
                    </div>
                    {node.hasNext && <i className="next-step-arrow fas fa-arrow-right" />}
                    </React.Fragment>
                    :
                    <WorkflowDiagramNode
                        name={node.name}
                        hasNext={node.hasNext}
                        status={node.status}/>
            ))}
        </div>
    );
}